import * as React from "react";

function SvgXtremepush(props, ref) {
  return (
    <svg
      id="Xtremepush_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Xtremepush_svg__st0{fill:#bbc0c1}"}</style>
      <path
        id="Xtremepush_svg__path5077_9_"
        className="Xtremepush_svg__st0"
        d="M384.4 158.3c-5.4 9.8-5.5 20.9-4.5 32.4 29.1 4 52 27 56.1 56.1 15.6.8 24.6-.3 32.4-4.5-6.1-43.5-40.5-77.9-84-84z"
      />
      <path
        id="Xtremepush_svg__path5079_7_"
        d="M150.4 321.3c12.9-1.7 24.2-6.6 32.4-14.2 12-11.1 38.7-39.2 50.5-51.5-17.6-17.8-46.2-46.5-50.5-50.5-8.2-7.6-19.5-12.6-32.4-14.2-.3-13.5 1-22.2 4.2-32.4 18.7 2.4 36.5 9.8 50.4 22.6 7.6 7 34 33.7 51.2 51.2 11.6-12.1 36.2-37.9 50.5-51.2 13.9-12.9 31.7-20.3 50.4-22.7 3.7 9.1 4.7 22.5 4.2 32.4-12.9 1.7-24.2 6.6-32.4 14.2-12.1 11.2-38.3 38.5-49.8 50.5 6.8 7.1 13.1 13.7 21.7 22.6 12.9 13.5 26.2 27 28.1 28.9 8.2 7.6 19.5 12.6 32.4 14.2 1 10.3 0 23.8-4.2 32.4-18.7-2.4-36.5-9.8-50.4-22.6-5.3-4.9-16.6-16.8-29.6-30.3-8.3-8.6-14.2-14.8-20.9-21.8-13.3 14-37.7 39.5-51.3 52-13.9 12.9-31.8 20.3-50.4 22.7-4-6.7-5.6-20.2-4.1-32.3z"
        fill="#1e87c8"
      />
      <path
        id="Xtremepush_svg__path5081_9_"
        className="Xtremepush_svg__st0"
        d="M75.8 265.2c-11.8-.7-22.5 0-32.4 4.5 6.1 43.5 40.5 77.9 83.9 83.9 4.7-10.9 5-21.3 4.5-32.4-29-3.9-52-26.9-56-56z"
      />
      <path
        id="Xtremepush_svg__path5083_9_"
        className="Xtremepush_svg__st0"
        d="M384.4 353.7c-5.4-9.8-5.5-20.9-4.5-32.4 29.1-4 52-27 56.1-56.1 15.6-.8 24.6.3 32.4 4.5-6.1 43.5-40.5 77.9-84 84z"
      />
      <path
        id="Xtremepush_svg__path5085_9_"
        className="Xtremepush_svg__st0"
        d="M75.8 246.8c-11.8.7-22.5 0-32.4-4.5 6.1-43.5 40.5-77.9 83.9-83.9 4.7 10.9 5 21.3 4.5 32.4-29 3.9-52 26.9-56 56z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgXtremepush);
